<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <div class="pt-lg-md" style="width: 100%; padding: 0 100px 0 100px">
            <div class="row justify-content-center">
                <v-card style="display: flex; flex-direction: row; width: 100%" class="p-4">
                    <div style="flex: 1; min-width: 0">
                        <v-text-field
                                v-model="searchInput"
                                style="width: 40%;"
                                :class="[isEN ? 'mb-3':'direction-rtl mb-3']"
                                flat
                                hide-details
                                :placeholder="language.lang('Search articles and news ...')"
                                prepend-inner-icon="mdi-magnify"
                        ></v-text-field>
                        <span class="mb-5" v-if="searchInput != null && searchInput.length > 0">{{language.lang('Search result: ')}}</span>
                        <div style="display: flex; flex-wrap: wrap"
                             v-if="searchInput != null && searchInput.length > 0">
                            <v-col cols="12" md="4" v-for="(item, index) in searchList" :key="index"
                                   class="mt-1 mb-1 mr-auto"
                                   @click="$router.push({name: 'article', params: {id: item.blog_id}})">
                                <div v-ripple style="width: 250Px;">
                                    <img style="width: 250Px; height: calc(250px * (9 / 16));"
                                         :src="item.blog_poster"
                                         class="card-img">
                                    <div class="p-2">
                                        <h6 class="">{{item.blog_title}}</h6>
                                        <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>
                                    </div>
                                </div>
                            </v-col>
                        </div>
                        <v-tabs :show-arrows="false" class="mb-3"
                                v-if="searchInput == null || searchInput.length == 0" v-model="tab"
                                align-with-title>
                            <v-tabs-slider color="#42C7D5;"></v-tabs-slider>
                            <v-tab v-for="(model, i) in items" :key="i" :href="'#tab-' + i">
                                {{ model.category_name }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-if="searchInput == null || searchInput.length == 0" v-model="tab">
                            <v-tab-item v-for="(tab, j) in items" :key="j" :value="'tab-' + j">
                                <div style="display: flex; flex-wrap: wrap"
                                     v-if="tab.children != null && tab.children.length > 0">
                                    <v-col cols="12" md="4" v-for="(item, index) in tab.children" :key="index"
                                           class="mt-1 mb-1 mr-auto"
                                           @click="$router.push({name: 'article', params: {id: item.blog_id}})">
                                        <div v-ripple class="response-size">
                                            <img
                                                    :src="item.blog_poster"
                                                    class="card-img response-size response-height">
                                            <div class="p-2">
                                                <h6 class="">{{item.blog_title}}</h6>
                                                <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>
                                            </div>
                                        </div>
                                    </v-col>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <div :class="isEN ? 'ml-5' : 'mr-5'"
                         style="width: 1px; height: 100%; background-color: lightgray"></div>
                    <div class="ml-3 mr-2 response-hidden" style="width: auto; height: auto;">
                        <h5 class="ml-3 mr-3 font-weight-bold">{{language.lang(`Most Visited:`)}}</h5>
                        <div v-for="(item, index) in views" :key="index" class="m-3"
                             @click="$router.push({name: 'article', params: {id: item.blog_id}})">
                            <div v-ripple class="card shadow border-0">
                                <div style="width: 300Px;">
                                    <img style="width: 300Px; height: calc(300px * (9 / 16));" :src="item.blog_poster"
                                         class="card-img">
                                    <div class="p-2">
                                        <h6 class="">{{item.blog_title}}</h6>
                                        <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 class="ml-3 mr-3 mt-5 font-weight-bold">{{language.lang("Top Articles:")}}</h5>
                        <div v-for="(item, index) in tops" :key="index" class="m-3"
                             @click="$router.push({name: 'article', params: {id: item.blog_id}})">
                            <div v-ripple class="card shadow border-0">
                                <div style="width: 300Px;">
                                    <img style="width: 300Px; height: calc(300px * (9 / 16));" :src="item.blog_poster"
                                         class="card-img">
                                    <div class="p-2">
                                        <h6 class="">{{item.blog_title}}</h6>
                                        <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        name: "blogs",
        data: () => ({
            searchList: [],
            searchInput: null,
            language: language,
            isEN: oracle.isEN(),
            views: [],
            tops: [],
            oracle: oracle,
            tab: null,
            items: []
        }), methods: {}, watch: {
            searchInput: function (to, from) {
                if (to.length > 0) {
                    oracle.axios('blog/getList', {search_by: to, order_by: 'priority', limit_by: 100}, (response) => {
                        this.searchList = response.data
                    })
                }
            }
        },
        mounted() {
            oracle.axios('blogCategory/getList', {order_by: 'priority', limit_by: 150}, (response) => {
                let array = [{'category_id': null, children: [], 'category_name': this.language.lang(`All Articles`)}]
                for (let i = 0; i < response.data.length; i++) {
                    response.data[i].children = []
                    array.push(response.data[i])
                }
                this.items.push(...array)
                this.items.forEach((item) => {
                    oracle.axios('blog/getList', {
                        'limit_by': 100,
                        order_by: 'priority',
                        'parent_by': item.category_id
                    }, (response) => {
                        item.children = response.data
                    })
                })
            })
            oracle.axios('blog/getList', {order_by: 'priority', limit_by: 3}, (response) => {
                this.tops = response.data
            })
            oracle.axios('blog/getList', {order_by: 'blog_views', limit_by: 3}, (response) => {
                this.views = response.data
            })
        }
    };
</script>
<style>
    .response-size {
        width: 250Px;
    }

    .response-height {
        height: calc(250px * (9 / 16));
    }

    .direction-rtl {
        direction: rtl !important;
    }

    @media only screen and (max-width: 1200px) {
        .response-hidden {
            display: none;
        }
    }

    @media only screen and (max-width: 1400px) {

        .response-size {
            width: auto;
        }

        .response-height {
            height: calc(300px * (9 / 16));

        }
    }


</style>
